import { render } from "./FaqIpcElement.vue?vue&type=template&id=61d96e13&scoped=true"
import script from "./FaqIpcElement.vue?vue&type=script&lang=js"
export * from "./FaqIpcElement.vue?vue&type=script&lang=js"

import "./FaqIpcElement.vue?vue&type=style&index=0&id=61d96e13&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d96e13"]])

export default __exports__